// src/features/profile/api/profile/read.js

import axiosInstance from '@/lib/axios';



export async function fetchNotifications() {
    const response = await axiosInstance.get('/notification/all');

    return response.data;
}


export async function adminFetchNotification() {

    const response = await axiosInstance.get('/admin/notifications');

    return response.data


}

export async function updateNotification(id) {

    const response = await axiosInstance.patch(`/notification/${id}`);
    return response.data;


}







export async function deleteLatestNotification(id) {
    return
    const response = await axiosInstance.delete(`/notification/match/${id}`);
    return response.data;


}


